import { Button } from '../../Atoms/Button';
import { useNavigate } from 'react-router-dom';
import { Fade } from 'react-awesome-reveal';
import { IoChevronForwardOutline } from 'react-icons/io5';
import { BsArrowRightShort } from 'react-icons/bs';

export default function ConnectWithUs() {
  const navigate = useNavigate();

  return (
    <section className="blade-padding bg-light-gradient-white">
      <section className="containers-min mx-auto font-gilroylight">
        <div className='flex justify-between items-center'>
          <div className="w-1/2">
            <h3 className="text-start font-gilroy">
              Online Infrastracture Estimate
            </h3>
            <p className="my-3 md:my-5 lg:my-7 text-start font-poppins font-light">
              Estimate your EV charging infrastructure procurement and installation costs
            </p>
          </div>
          <div className='w-1/2 text-end'>
            <div
              className='mt-5'
              onClick={() => {
                navigate('/fleet-calculator')
              }}
            >
              <button
                className='btn-new font-semibold relative flex justify-center items-center rounded-full pl-16 pr-6 font-poppins'
              >
                <span className="flex justify-center items-center">
                  <IoChevronForwardOutline className="h-[22px] w-[25px] ioArrow" />
                  <BsArrowRightShort className="h-[30px] w-[30px] tailArrow" />
                </span>
                Get Started
              </button>
            </div>
          </div>
        </div>
      </section>
    </section >
  );
}
